import Vue from "vue";

export default Vue.extend({
  template: `
    <input 
      type="time" 
      @change="changeHandler($event)"
      :value="params.value"
    />
`,
  data() {
    return {
      time: "",
    };
  },
  methods: {
    isPopUp() {
      return false;
    },
    changeHandler(event) {
      this.time = event.target.value;
      if (this.params.data.remarks) {
        this.params.data.remarks[this.params.colDef.field] = this.time;
      }
    },
    getValue() {
      return this.time;
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgGridCellTimeEditor.js